module.exports = __webpack_public_path__ + "img/18699.7fc9a5c1.jpg";